export enum OwnershipTransferCustomerStep {
  SelectPackage = 'SelectPackage',
  CellcomDu = 'CellcomDu',
  EquipmentObligations = 'EquipmentObligations',
  SubscriberPersonalData = 'SubscriberPersonalData',
  AddressForm = 'AddressForm',
  CustomerPaymentMethod = 'CustomerPaymentMethod',
  GeneralMessage = 'GeneralMessage',
}

export enum PopupEnum {
  ServiceFormPopup = 'ServiceFormPopup',
  CustomerValidationResult = 'CustomerValidationResult',
}

export enum FormSendType {
  sms = 'sms',
  email = 'email',
}
export enum EquipmentPaymentObligation {
  None = 0, //אין חיובים
  Customer = 1, //העברת החיוב למנוי"
  Organization = 2, //העברת החיוב לחשבון החברה
}

export enum RequestStatus {
  SentForSignature = 'SentForSignature',
  AwaitingContactPersonSignature = 'AwaitingContactPersonSignature',
  AwaitingForJoin = 'AwaitingForJoin',
  SignedAwaitingForJoin = 'SignedAwaitingForJoin',
  Signed = 'Signed',
  Expired = 'Expired',
  Cancelled = 'Cancelled',
  TransferredForManualProcessing = 'TransferredForManualProcessing',
  Finished = 'Finished',
}

export const MessageContent = {
  GeneralError: {
    title: 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת',
    secondTitle: 'באפשרותך לנסות שוב או לפנות לאיש הקשר',
    icon: require('../../OwnershipTransferBlock/Icons/error.svg'),
    report: 'customerGeneralError',
  },
  OwnershipTransferSuccess: {
    title: 'העברת בעלות מעסקי לפרטי למנוי מספר {customerPhoneNumber} הושלמה בהצלחה!',
    icon: require('../../OwnershipTransferBlock/Icons/v.svg'),
    report: 'ownershipTransferSuccess',
  },
  FormSendSuccess: {
    title: 'קבלנו את הפרטים שלך להעברת הבעלות, נציגנו יצרו איתך קשר בהקדם להשלמת התהליך',
    secondTitle: 'מספר פניה: {fuNumber}',
    icon: require('../../OwnershipTransferBlock/Icons/v.svg'),
    report: 'formSendSuccess',
  },
  PaymentFailed: {
    icon: require('../../OwnershipTransferBlock/Icons/error.svg'),
    title: 'קבלנו את הפרטים שלך להעברת הבעלות, נציגנו יצרו איתך קשר בהקדם להשלמת התהליך',
  },
  AccountError: {
    icon: require('../../OwnershipTransferBlock/Icons/error.svg'),
    title: 'המנוי לא משויך',
    secondTitle: 'על פי הפרטים שאצלנו, בוצע שינוי בפרטי המנוי ולכן לא ניתן להמשיך, לבירורים ניתן לפנות לאיש הקשר',
  },
  LinkExpired: {
    icon: require('../../OwnershipTransferBlock/Icons/error.svg'),
    title: 'הקישור לא בתוקף',
    secondTitle: 'אפשר לפנות לאיש קשר לקבלת קישור חדש',
    report: 'linkExpired',
  },
  AbroadError: {
    icon: require('../../OwnershipTransferBlock/Icons/error.svg'),
    title: `המנוי נמצא בחו''ל`,
    secondTitle: `לא ניתן להעביר בעלות למנוי שנמצא בחו''ל`,
    report: 'customerAbroadError',
  },
  ErrorSubStatus: {
    icon: require('../../OwnershipTransferBlock/Icons/error.svg'),
    title: 'המנוי שלך מושהה',
    secondTitle: `לא ניתן להעביר מנוי בסטטוס מושהה, להמשך טיפול אפשר לפנות לאיש הקשר`,
    report: 'customerErrorSubStatus',
  },
  ErrorNPStatus: {
    icon: require('../../OwnershipTransferBlock/Icons/error.svg'),
    title: 'המנוי שלך נמצא בתהליך ניוד',
    secondTitle: `לא ניתן להשלים את העברת הבעלות בזמן תהליך ניוד`,
    report: 'customerErrorNPStatus',
  },
  ManualProgress: {
    icon: require('../../OwnershipTransferBlock/Icons/v.svg'),
    title: 'קבלנו את הפרטים שלך להעברת הבעלות, נציגנו יצרו איתך קשר בהקדם להשלמת התהליך',
    secondTitle: 'מספר פניה: {fuNumber}',
  },
};

export const PopupMessageContent = {
  FutureAbroadPackage: {
    icon: require('../../OwnershipTransferBlock/Icons/error.svg'),
    title: 'חבילת חו״ל עתידית   ',
    secondTitle: `לתשומת ליבך, זיהינו שיש לך חבילת חו''ל עתידית והיא לא תועבר במסגרת העברת הבעלות. לאחר העברת הבעלות יש להתקין חבילת חו''ל חדשה דרך מוקד השירות`,
    buttonText: 'הבנתי, תודה',
    buttonClick: 'nextStepAfterStatusValidation',
  },
  WaitingForCPSignature: {
    icon: require('../Icons/signature.svg'),
    title: 'כדי להעביר בעלות על הקו אנחנו צריכים את החתימות של איש הקשר בארגון שלך',
    secondTitle:
      'טפסי העברת בעלות נשלחו לאיש הקשר בארגון, לאחר חתימה שלו יתקבלו טפסים גם לחתימה שלך. רק לאחר החתימות יהיה ניתן להמשיך בתהליך.',
    buttonText: 'הבנתי, תודה',
    buttonClick: 'closePopup',
    report: 'waitingForSignature',
  },
  // WaitingForCustomerSignature: {
  //   icon: require('../Icons/signature.svg'),
  //   title: 'אנחנו צריכים את החתימה שלך <br /> כדי להעביר את הבעלות על הקו',
  //   secondTitle: 'טפסי העברת הבעלות נשלחו בהודעה נפרדת.<br />ללא החתימה שלך לא ניתן להמשיך בתהליך',
  //   buttonText: 'חתמתי, אפשר להמשיך',
  //   buttonClick: 'validateSignatureStatus',
  //   report: 'waitingForSignature',
  // },
  PaymentFailed: {
    icon: require('../Icons/errorSign.svg'),
    title: 'מצטערים אבל התשלום לא בוצע',
    secondTitle: 'נסה שנית או החלף אמצעי תשלום',
    buttonText: 'אני רוצה לנסות שוב',
    buttonClick: 'closePopup',
  },
};
